import { IEmployerList } from '../Models';
import { IEmployerLight } from '../Models';
import { IEmployerFilterParams } from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const EmployerService = {
    async getAllEmployers(
        searchParams: IEmployerFilterParams,
        signal?: AbortSignal
    ): Promise<IEmployerList> {
        const response = await fetch('/Api/Employers/GetAllEmployers', {
            method: 'POST',
            body: JSON.stringify(searchParams),
            headers,
            signal,
        });
        return await response.json();
    },
    async getLabelisedEmployers(
        searchParams: IEmployerFilterParams,
        signal?: AbortSignal
    ): Promise<Record<string, IEmployerLight[]>> {
        const response = await fetch(
            '/Api/Employers/GetAllLabelisedEmployers',
            {
                method: 'POST',
                body: JSON.stringify(searchParams),
                headers,
                signal,
            }
        );
        return await response.json();
    },
    async getAllEmployersName(): Promise<string[]> {
        const response = await fetch('/Api/Employers/GetAllEmployersName', {
            headers,
        });
        return await response.json();
    },
};
